import classNames from "classnames";
import Button from "../Button/Button";
import styles from "./TablePaginationPages.module.scss";

const MAX_PAGES_TO_SHOW = 7;

interface TablePaginationPagesProps {
  pageCount: number;
  pageIndex: number;
  onSelectPage: (page: number) => void;
}

function TablePaginationPages({
  pageCount,
  pageIndex,
  onSelectPage,
}: TablePaginationPagesProps) {
  const pages = Array.from(Array(pageCount).keys());

  if (pageCount < MAX_PAGES_TO_SHOW) {
    return (
      <div className={styles.container}>
        {pages.map((page) => (
          <Button
            className={classNames(styles.button, {
              [styles.buttonActive]: page === pageIndex,
            })}
            key={page}
            onClick={() => {
              onSelectPage(page);
            }}
            variant="unstyled"
          >
            {page + 1}
          </Button>
        ))}
      </div>
    );
  }

  if (pageIndex < 2 || pageIndex > pageCount - 3) {
    return (
      <div className={styles.container}>
        {pages.slice(0, 3).map((page) => (
          <Button
            className={classNames(styles.button, {
              [styles.buttonActive]: page === pageIndex,
            })}
            key={page}
            onClick={() => {
              onSelectPage(page);
            }}
            variant="unstyled"
          >
            {page + 1}
          </Button>
        ))}
        <span className={styles.dots}>...</span>
        {pages.slice(-3).map((page) => (
          <Button
            className={classNames(styles.button, {
              [styles.buttonActive]: page === pageIndex,
            })}
            key={page}
            onClick={() => {
              onSelectPage(page);
            }}
            variant="unstyled"
          >
            {page + 1}
          </Button>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Button
        className={classNames(styles.button, {
          [styles.buttonActive]: pageIndex === 0,
        })}
        onClick={() => {
          onSelectPage(0);
        }}
        variant="unstyled"
      >
        1
      </Button>
      {pageIndex === pageCount - 3 && (
        <Button
          className={classNames(styles.button, {
            [styles.buttonActive]: pageIndex === 2,
          })}
          onClick={() => {
            onSelectPage(pageCount - 2);
          }}
          variant="unstyled"
        >
          {2}
        </Button>
      )}
      {pageIndex > 2 && <span className={styles.dots}>...</span>}
      {pages.slice(pageIndex - 1, pageIndex + 2).map((page) => (
        <Button
          className={classNames(styles.button, {
            [styles.buttonActive]: page === pageIndex,
          })}
          key={page}
          onClick={() => {
            onSelectPage(page);
          }}
          variant="unstyled"
        >
          {page + 1}
        </Button>
      ))}
      {pageIndex < pageCount - 3 && <span className={styles.dots}>...</span>}
      {pageIndex === 2 && (
        <Button
          className={classNames(styles.button, {
            [styles.buttonActive]: pageIndex === pageCount - 2,
          })}
          onClick={() => {
            onSelectPage(pageCount - 2);
          }}
          variant="unstyled"
        >
          {pageCount - 1}
        </Button>
      )}
      <Button
        className={classNames(styles.button, {
          [styles.buttonActive]: pageIndex === pageCount - 1,
        })}
        onClick={() => {
          onSelectPage(pageCount - 1);
        }}
        variant="unstyled"
      >
        {pageCount}
      </Button>
    </div>
  );
}

export default TablePaginationPages;
